/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListTimetableCoursesParams,
  PaginatedTimetableCourses,
  SchemaValidationErrorResponse,
  TimetableCourse,
  TimetableCourseCreateInput,
  TimetableCourseDestroyPreview,
  TimetableCourseUpdateInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * Create a new course for a specific calendar
 * @summary Create a new course
 */
export const createTimetableCourse = (
    calendarId: MaybeRefOrGetter<string>,
    timetableCourseCreateInput?: MaybeRefOrGetter<TimetableCourseCreateInput>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
timetableCourseCreateInput = toValue(timetableCourseCreateInput);

      return axiosClient<TimetableCourse>(
      {url: `/timetable/calendars/${calendarId}/courses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timetableCourseCreateInput, signal
    },
      );
    }




export const getCreateTimetableCourseMutationKey = () => ['createTimetableCourse'] as const;

export const getCreateTimetableCourseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableCourse>>, TError,CreateTimetableCourseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTimetableCourse>>, TError,CreateTimetableCourseMutationVariables, TContext> => {

const mutationKey = getCreateTimetableCourseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTimetableCourse>>, CreateTimetableCourseMutationVariables> = (props) => {
          const {calendarId,data} = props ?? {};

          return  createTimetableCourse(calendarId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTimetableCourseMutationResult = NonNullable<Awaited<ReturnType<typeof createTimetableCourse>>>
    export type CreateTimetableCourseMutationBody = TimetableCourseCreateInput | undefined
    export type CreateTimetableCourseMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateTimetableCourseMutationVariables = {calendarId: string;data?: TimetableCourseCreateInput}

    /**
 * @summary Create a new course
 */
export const useCreateTimetableCourse = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableCourse>>, TError,CreateTimetableCourseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTimetableCourse>>,
        TError,
        CreateTimetableCourseMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTimetableCourseMutationOptions(options), queryClient);
    }
    /**
 * Returns a paginated list of courses for a specific calendar
 * @summary List courses for a calendar
 */
export const listTimetableCourses = (
    calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableCoursesParams>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
params = toValue(params);

      return axiosClient<PaginatedTimetableCourses>(
      {url: `/timetable/calendars/${calendarId}/courses`, method: 'GET',
        params, signal
    },
      );
    }




export const getListTimetableCoursesQueryKey = (calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableCoursesParams>,) => {
    return [
    'timetable','calendars',calendarId,'courses', ...(params ? [params] : [])
    ] as const;
    }


export const getListTimetableCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listTimetableCourses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTimetableCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTimetableCoursesQueryKey(calendarId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTimetableCourses>>> = ({ signal }) => listTimetableCourses(calendarId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(calendarId) !== null && toValue(calendarId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTimetableCourses>>, TError, TData>
}

export type ListTimetableCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listTimetableCourses>>>
export type ListTimetableCoursesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List courses for a calendar
 */

export function useListTimetableCourses<TData = Awaited<ReturnType<typeof listTimetableCourses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 calendarId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListTimetableCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTimetableCourses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTimetableCoursesQueryOptions(calendarId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Soft delete a course (sets discarded_at)
 * @summary Delete a course
 */
export const deleteTimetableCourse = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${calendarId}/courses/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteTimetableCourseMutationKey = () => ['deleteTimetableCourse'] as const;

export const getDeleteTimetableCourseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableCourse>>, TError,DeleteTimetableCourseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableCourse>>, TError,DeleteTimetableCourseMutationVariables, TContext> => {

const mutationKey = getDeleteTimetableCourseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTimetableCourse>>, DeleteTimetableCourseMutationVariables> = (props) => {
          const {calendarId,id} = props ?? {};

          return  deleteTimetableCourse(calendarId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTimetableCourseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTimetableCourse>>>

    export type DeleteTimetableCourseMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteTimetableCourseMutationVariables = {calendarId: string;id: string}

    /**
 * @summary Delete a course
 */
export const useDeleteTimetableCourse = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableCourse>>, TError,DeleteTimetableCourseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTimetableCourse>>,
        TError,
        DeleteTimetableCourseMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTimetableCourseMutationOptions(options), queryClient);
    }
    /**
 * Returns details of a specific course
 * @summary Get a specific course
 */
export const getTimetableCourse = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<TimetableCourse>(
      {url: `/timetable/calendars/${calendarId}/courses/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetTimetableCourseQueryKey = (calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'timetable','calendars',calendarId,'courses',id
    ] as const;
    }


export const getGetTimetableCourseQueryOptions = <TData = Awaited<ReturnType<typeof getTimetableCourse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimetableCourse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetTimetableCourseQueryKey(calendarId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimetableCourse>>> = ({ signal }) => getTimetableCourse(calendarId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(calendarId) !== null && toValue(calendarId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimetableCourse>>, TError, TData>
}

export type GetTimetableCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getTimetableCourse>>>
export type GetTimetableCourseQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get a specific course
 */

export function useGetTimetableCourse<TData = Awaited<ReturnType<typeof getTimetableCourse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimetableCourse>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimetableCourseQueryOptions(calendarId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Update an existing course
 * @summary Update a course
 */
export const updateTimetableCourse = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    timetableCourseUpdateInput?: MaybeRefOrGetter<TimetableCourseUpdateInput>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);
timetableCourseUpdateInput = toValue(timetableCourseUpdateInput);

      return axiosClient<TimetableCourse>(
      {url: `/timetable/calendars/${calendarId}/courses/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: timetableCourseUpdateInput, signal
    },
      );
    }




export const getUpdateTimetableCourseMutationKey = () => ['updateTimetableCourse'] as const;

export const getUpdateTimetableCourseMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimetableCourse>>, TError,UpdateTimetableCourseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTimetableCourse>>, TError,UpdateTimetableCourseMutationVariables, TContext> => {

const mutationKey = getUpdateTimetableCourseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTimetableCourse>>, UpdateTimetableCourseMutationVariables> = (props) => {
          const {calendarId,id,data} = props ?? {};

          return  updateTimetableCourse(calendarId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTimetableCourseMutationResult = NonNullable<Awaited<ReturnType<typeof updateTimetableCourse>>>
    export type UpdateTimetableCourseMutationBody = TimetableCourseUpdateInput | undefined
    export type UpdateTimetableCourseMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdateTimetableCourseMutationVariables = {calendarId: string;id: string;data?: TimetableCourseUpdateInput}

    /**
 * @summary Update a course
 */
export const useUpdateTimetableCourse = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimetableCourse>>, TError,UpdateTimetableCourseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateTimetableCourse>>,
        TError,
        UpdateTimetableCourseMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTimetableCourseMutationOptions(options), queryClient);
    }
    /**
 * Returns the number of affected events without actually deleting the course
 * @summary Preview course deletion
 */
export const previewDeleteTimetableCourse = (
    calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
id = toValue(id);

      return axiosClient<TimetableCourseDestroyPreview>(
      {url: `/timetable/calendars/${calendarId}/courses/${id}/destroy_preview`, method: 'GET', signal
    },
      );
    }




export const getPreviewDeleteTimetableCourseQueryKey = (calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'timetable','calendars',calendarId,'courses',id,'destroy_preview'
    ] as const;
    }


export const getPreviewDeleteTimetableCourseQueryOptions = <TData = Awaited<ReturnType<typeof previewDeleteTimetableCourse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewDeleteTimetableCourse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPreviewDeleteTimetableCourseQueryKey(calendarId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewDeleteTimetableCourse>>> = ({ signal }) => previewDeleteTimetableCourse(calendarId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(calendarId) !== null && toValue(calendarId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewDeleteTimetableCourse>>, TError, TData>
}

export type PreviewDeleteTimetableCourseQueryResult = NonNullable<Awaited<ReturnType<typeof previewDeleteTimetableCourse>>>
export type PreviewDeleteTimetableCourseQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Preview course deletion
 */

export function usePreviewDeleteTimetableCourse<TData = Awaited<ReturnType<typeof previewDeleteTimetableCourse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 calendarId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewDeleteTimetableCourse>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewDeleteTimetableCourseQueryOptions(calendarId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






